<ion-row>
  <ion-col
    [ngClass]="{
      'chart-margin': !_chartTypes.Aar.active,
      'm-t': isBrowser && _chartTypes.Aar.active,
      'lg-space-l': true
    }"
    size="12"
  >
    <div *ngIf="_chartTypes.Aar.active">
      <div class="chart-container" *ngIf="!hasFetchingError; else fetchFailed">
        <app-year-chart-price
          *ngIf="valgtAarAnlegg; else loadingTemplate"
          [selectedDate]="minDate"
          [valgtAnlegg]="valgtAarAnlegg"
        ></app-year-chart-price>
      </div>
    </div>
    <div *ngIf="_chartTypes.Maaned.active">
      <div class="chart-container" *ngIf="!hasFetchingError; else fetchFailed">
        <app-month-chart-price
          *ngIf="valgtMaanedAnlegg; else loadingTemplate"
          [selectedDate]="selectedDateMonth"
          [valgtAnlegg]="valgtMaanedAnlegg"
          [isStromstotteToggled]="isStromstotteToggled"
        ></app-month-chart-price>
      </div>
    </div>
    <div *ngIf="_chartTypes.Dag.active">
      <div class="chart-container" *ngIf="!hasFetchingError; else fetchFailed">
        <app-day-chart-price
          *ngIf="valgtDagAnlegg; else loadingTemplate"
          [selectedDate]="selectedDateDay"
          [valgtAnlegg]="valgtDagAnlegg"
          [isStromstotteToggled]="isStromstotteToggled"
        ></app-day-chart-price>
      </div>
    </div>
    <div *ngIf="_chartTypes.Time.active">
      <div class="chart-container" *ngIf="!hasFetchingError; else fetchFailed">
        <app-hour-chart-price
          *ngIf="valgtTimeAnlegg; else loadingTemplate"
          [selectedDate]="selectedDateHour"
          [valgtAnlegg]="valgtTimeAnlegg"
          [isStromstotteToggled]="isStromstotteToggled"
        ></app-hour-chart-price>
      </div>
    </div>
  </ion-col>
</ion-row>

<ng-template #fetchFailed>
  <div class="chart-container error">
    <div class="errorMessage">
      <ion-icon name="warning-outline" class="errorIcon"></ion-icon>
    </div>
    <p class="errorMessage">
      Klarte ikke hente data. Prøv igjen senere eller kontakt oss om problemet
      vedvarer.
    </p>
  </div>
</ng-template>

<ng-template #loadingTemplate>
  <div class="loadingContainer">
    <ion-spinner name="dots"></ion-spinner>
  </div>
</ng-template>
